import type { EventClient, AccountContext } from '~/lib/types/EventClient'
import type { CampaignSubmitPayload, CampaignEntryAcceptPayload, CampaignCreatePayload } from '~/lib/types/Event'

export class MockEventClient implements EventClient {
  private events: Array<{
    type: string
    payload: unknown
    timestamp: number
  }> = []
  private accountContext: AccountContext | null = null

  async sendCampaignSubmit(payload: CampaignSubmitPayload): Promise<void> {
    this.logEvent('CAMPAIGN_SUBMIT', payload)
  }

  async sendCampaignEntryAccept(payload: CampaignEntryAcceptPayload): Promise<void> {
    this.logEvent('CAMPAIGN_ENTRY_ACCEPT', payload)
  }

  async sendCampaignCreate(payload: CampaignCreatePayload): Promise<void> {
    this.logEvent('CAMPAIGN_CREATE', payload)
  }

  setAccountContext(context: AccountContext): void {
    this.accountContext = context
  }

  clearAccountContext(): void {
    this.accountContext = null
  }

  async flush(): Promise<void> {
    console.log('[MockEventClient] Flush called')
  }

  async destroy(): Promise<void> {
    console.log('[MockEventClient] Destroy called')
    this.events = []
  }

  getEvents() {
    return [...this.events]
  }

  clearEvents() {
    this.events = []
  }

  private logEvent(type: string, payload: unknown): void {
    const timestamp = Date.now()
    const originalPayload = payload as { custom: Record<string, unknown> }
    const enrichedPayload = {
      ...originalPayload,
      custom: {
        ...originalPayload.custom,
        timestamp,
        ...(this.accountContext && {
          adv_account_id: this.accountContext.adv_account_id,
          user_adv_id: this.accountContext.user_adv_id,
        }),
      },
    }

    const event = {
      type,
      payload: enrichedPayload,
      timestamp,
    }

    this.events.push(event)
    console.log(`[MockEventClient] Event sent:`, event)
  }
}
